import script from "./service.vue?vue&type=script&lang=ts&setup=true"
export * from "./service.vue?vue&type=script&lang=ts&setup=true"

import "./service.vue?vue&type=style&index=0&id=5e42c6c7&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e42c6c7"]])

export default __exports__